export interface DemographicType{
    key: number;
    name: string;
}

export const DemographicTypes: DemographicType[] = [
    { key: 0, name: "All Users" },
    { key: 1, name: "Teens (14-17)" },
    { key: 2, name: "Young Adults (18-24)" },
    { key: 3, name: "Adults (25-64)" },
    { key: 4, name: "Seniors (65+)" },
]